import { render } from "./B_Puppies.vue?vue&type=template&id=2fe4aa76&scoped=true"
import script from "./B_Puppies.vue?vue&type=script&lang=js"
export * from "./B_Puppies.vue?vue&type=script&lang=js"

import "./B_Puppies.vue?vue&type=style&index=0&id=2fe4aa76&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe4aa76"]])

export default __exports__